import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HeaderReachBeforeAfterValue } from '@reach/interfaces/headers/reach-header.interface';

import { SessionService } from '~app-client/core/services';
import { CLIENT_ENVIRONMENT } from '~app-client/core/tokens';
import { ClientUser } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class HandleHeadersInterceptor implements HttpInterceptor {
	private readonly sessionService = inject(SessionService);
	private readonly environment = inject(CLIENT_ENVIRONMENT);

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (!req.url.startsWith(this.environment.apiBaseUrl)) {
			return next.handle(req);
		}

		return next.handle(req);
	}

	private setUserParameter<KEY extends keyof ClientUser>(
		value: ClientUser[KEY] | null,
		userParam: KEY
	): void {
		try {
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
			if (value !== null && value !== undefined) {
				this.sessionService.addData({ [userParam]: value });
			}
		} catch (error) {
			console.error(error);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-private-class-members
	private setBeforeAfterUserParameter<KEY extends keyof ClientUser>(
		value: HeaderReachBeforeAfterValue<ClientUser[KEY]> | null,
		userParam: KEY
	): void {
		const after = value?.after;
		if (after) {
			this.setUserParameter(after, userParam);
		}
	}
}
